import { ArrowDropDown, Description, PictureAsPdf } from "@mui/icons-material";
import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const ExportButton = ({ onExportPDF }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  const handleMenuItemClick = (exportType) => {
    if (exportType === "pdf") {
      onExportPDF();
    }
    setOpen(false);
  };

  const handleToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <ButtonGroup
        variant="contained"
        ref={anchorRef}
        className="btn-round"
        sx={{
          "& .MuiButton-root": {
            backgroundColor: colorPrimary,
            borderColor: colorPrimary,
            borderRadius: "25px",
            color: "white",
            "&:hover": {
              backgroundColor: colorPrimary,
            },
            "&:focus": {
              backgroundColor: colorPrimary,
            },
            "&:first-of-type": {
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
            },
            "&:last-of-type": {
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              minWidth: "auto",
            },
          },
        }}
      >
        <Button
          size="small"
          onClick={handleToggle}
          onMouseDown={(e) => e.preventDefault()}
          disableRipple
          sx={{ px: 1 }}
        >
          {t("Export") || "Esporta"}
          <ArrowDropDown />
        </Button>
      </ButtonGroup>

      <Popper
        sx={{ zIndex: 1300 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        placement="bottom-start"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-start" ? "left top" : "left bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList>
                  <MenuItem onClick={() => handleMenuItemClick("pdf")}>
                    <ListItemIcon>
                      <PictureAsPdf sx={{ color: "#d32f2f" }} />
                    </ListItemIcon>
                    <ListItemText>{t("PDF") || "PDF"}</ListItemText>
                  </MenuItem>
                  <MenuItem disabled>
                    <ListItemIcon>
                      <Description sx={{ color: "#2e7d32" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={t("DOCX") || "DOCX"}
                      secondary={t("Coming Soon") || "prossimamente"}
                      sx={{
                        "& .MuiListItemText-secondary": {
                          fontSize: "0.75rem",
                          fontStyle: "italic",
                        },
                      }}
                    />
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default ExportButton;
